import { Reveal } from "../site/motion";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-background py-28 md:py-40">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-3">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-secondary">The Vision</p>
        </Reveal>
      </div>
      <div className="md:col-span-9 md:col-start-4">
        <Reveal>
          <h2 className="font-serif font-light text-foreground leading-[1.05] text-3xl sm:text-4xl lg:text-6xl">
            We believe addiction is a health condition — <span className="text-muted-foreground">not a moral failing.</span> Our mission is to strip away the stigma and replace it with skilled, humane, medically sound care.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-3xl">
          <p className="text-muted-foreground leading-relaxed">
            Amar Sagoo Nursing Inc is led by Amar Sagoo, a Family Nurse Practitioner (FNP), and built on more than fifteen years of frontline clinical experience in addiction medicine. We walk alongside people at every stage of recovery.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Every treatment plan is individualized, confidential, and grounded in the latest evidence — because lasting recovery is built on trust, not shame.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
